<script setup lang="ts">
import UIBanner from '@/components/ui/UIBanner.vue'
import { PhWarningCircle } from '@phosphor-icons/vue'

defineProps<{
  /** What text should be displayed in the banner? */
  bannerText: string
}>()
</script>

<template>
  <UIBanner variant="error">
    <div class="flex items-center space-x-[10px]">
      <PhWarningCircle size="24" class="text-inverse shrink-0" weight="fill" />
      <p
        class="text-left text-inverse pointer-events-auto"
        tabindex="0"
        role="status"
        :aria-label="bannerText"
      >
        {{ bannerText }}
      </p>
    </div>
  </UIBanner>
</template>
